import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-report-main',
  templateUrl: '../views/report-main.component.html',
  styleUrls: ['../../../css/report-main.component.css']
})
export class ReportMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/report/components/report-main.component.ts